export default __webpack_public_path__ + "static/media/rubbish-closed.d5c5afae.svg";